var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../Util";
export var disabledCheckStyle = "disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400";
var Checkbox = function (_a) {
    var id = _a.id, displayName = _a.displayName, disabled = _a.disabled, defaultChecked = _a.defaultChecked, error = _a.error, reactHookForm = _a.reactHookForm, onClick = _a.onClick, checked = _a.checked, onChange = _a.onChange;
    return (_jsx("input", __assign({ id: id, name: displayName, disabled: disabled, defaultChecked: defaultChecked, type: "checkbox", checked: checked, onChange: onChange, className: classNames("h-4 w-4 rounded text-blue-600 focus:ring-blue-500", disabledCheckStyle, error ? "border-red-300" : "border-gray-300"), onClick: onClick }, reactHookForm)));
};
export default Checkbox;
